// What Enter means in a search box whose first match is highlighted for you (MUI
// `autoHighlight`). ONE rule for every item search (owner, 2026-10-27): the POS, the
// Direct Invoice / Quotation / Sales Order grid, purchasing, counts, adjustments, labels,
// returns and Stock Transfer all resolve Enter here.
//
// The danger it exists for: with the first row pre-highlighted, a barcode scanner's
// burst (the code, then Enter) arrives as that ROW, not as the typed text — so a scan
// could add whatever product happened to sort first. An exact code therefore beats the
// highlight, and a scanned-looking code with no exact row goes to the exact scan.

// Digits only, 8 or more: an EAN-8/13 or UPC off a scanner, not something typed to browse.
export const LOOKS_SCANNED = /^\d{8,}$/;

const codeOf = (v) => (v == null ? "" : String(v).trim().toLowerCase());

/**
 * @param typed   the text in the box when Enter was pressed
 * @param picked  what the Autocomplete handed onChange (a row, a string, or null)
 * @param reason  why that row was highlighted — "auto" (MUI pre-selected the first
 *                match) or "keyboard" / "mouse" / "touch" (the person chose it)
 * @param options the rows on screen
 * @returns the row to use, or null to treat the typed text as an exact scan
 */
export const resolveEnterPick = ({ typed, picked, reason, options }) => {
  const row = picked && typeof picked === "object" ? picked : null;
  // A row the person arrowed to or pointed at is their choice; nothing overrides it.
  if (row && reason && reason !== "auto") return row;

  const code = codeOf(typed);
  if (code) {
    const exact = (options || []).find(
      (o) => o && (codeOf(o.barcode) === code || codeOf(o.skuCode) === code)
    );
    if (exact) return exact;
    if (LOOKS_SCANNED.test(code)) return null;
  }
  return row;
};
